<template>
  <div class>
    <!-- header start -->
    <van-nav-bar
      title="在线充值"
      left-arrow
      fixed
      :z-index="99"
      @click-left="onClickLeft"
      :border="false"
    />
    <div class="navBarSpace"></div>
    <!-- header end -->

    <div>
         <van-tabs
        sticky
        animated
        swipeable
        offset-top="46"
        title-active-color="#fff"
        title-inactive-color="#f2f2f2"
        background="#24a378"
        color="#fff"
        :border="false"
      >
        <van-tab title="普通充值">
          <recharge></recharge>
        </van-tab>
        <van-tab title="充值套餐">
          <rechargePackage></rechargePackage>
        </van-tab>
        <van-tab title="充值记录">
          <rechargeLog></rechargeLog>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>
<script>
import { Toast } from "vant";
import recharge from "@/components/user/recharge/recharge";
import rechargePackage from "@/components/user/recharge/rechargePackage";
import rechargeLog from "@/components/user/recharge/rechargeLog";
import { mapGetters } from "vuex";

export default {
  data() {
    return {};
  },
  components: {
    recharge,
    rechargePackage,
    rechargeLog
  },
  computed: {},
  mounted() {
    document
      .querySelector("body")
      .setAttribute("style", "background-color:#f2f2f2");
  },
  beforeDestroy() {
    document.querySelector("body").removeAttribute("style");
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    }
  },
  created() {
    var that = this;
    var _isWeiXin = that.$weixin.IsWeiXin();
    if (_isWeiXin) {
       var openid = sessionStorage.getItem("OpenId");
       if(openid==null){
          var code = that.$route.query.code;
          console.log("code:"+code);
          that.$weixin.weixinAuthorize(code, that, function() {});
       }
    }
    else{
      Toast("请使用微信浏览器打开，才能正确使用微信支付！");

    }
  }
};
</script>

<style scoped>
.form-setion {
  margin: 20px 0 20px;
}
.paystyle-list {
  display: flex;
  align-items: center;
}
.paystyle-list img {
  width: 32px;
  height: 32px;
  margin-right: 15px;
}
.paystyle-list .tit {
  font-size: 15px;
}
.paystyle-list .des {
  font-size: 12px;
  color: #999;
}
.paystyle-list .payDisableIcon {
  position: absolute;
  top: 0;
  right: 0;
  width: 40px;
  height: auto;
  margin: 0;
}
.payPackage-list {
  display: flex;
  align-items: center;
}
.payPackage-list > .name {
  font-size: 14px;
  color: orange;
  flex: 1;
}
.payPackage-list > .bd {
  flex: 2;
  display: flex;
  align-items: center;
  overflow: hidden;
}
.payPackage-list img {
  width: 24px;
  height: 24px;
  object-fit: contain;
  margin-right: 10px;
}
.payPackage-list .num {
  font-size: 14px;
  color: orange;
}
.recharge-list {
  background-color: #fff;
  overflow: hidden;
}
.recharge-list .tbody,
.recharge-list .thead {
  padding: 10px;
}
.recharge-list .thead {
  font-size: 13px;
  color: #888;
  padding-top: 20px;
}
.recharge-list .date {
  text-align: right;
}
.recharge-list .tbody .date {
  color: #999;
  font-size: 12px;
}
.recharge-list .price {
  text-align: center;
}
.recharge-list .tbody .price {
  font-size: 14px;
}
.recharge-list .tbody .code {
  font-size: 12px;
  word-break: break-all;
  word-wrap: break-word;
  overflow: hidden;
}
</style>
